import { render, staticRenderFns } from "./TestClassify.vue?vue&type=template&id=2bf64f7e&scoped=true"
import script from "./TestClassify.vue?vue&type=script&lang=js"
export * from "./TestClassify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf64f7e",
  null
  
)

export default component.exports